// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".departmentDropdown[data-v-c940b61a]{max-width:400px}.v-window__next[data-v-c940b61a],.v-window__prev[data-v-c940b61a]{background:transparent!important}.v-skeleton-loader__avatar[data-v-c940b61a]{height:80px;width:80px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
